export type AppleSystemAppMatch = {
  officialDisplayName: string;
  bundleId: string;
  isFirstPartyApple: boolean;
  brandfetchSearchQuery: string;
};

type AppleSystemAppDefinition = {
  displayName: string;
  bundleId: string;
  isFirstPartyApple: boolean;
  brandfetchSearchQuery?: string;
};

const APPLE_SYSTEM_APPS: AppleSystemAppDefinition[] = [
  { displayName: "App Store", bundleId: "com.apple.AppStore", isFirstPartyApple: true },
  { displayName: "App Store Connect", bundleId: "com.apple.AppStoreConnect", isFirstPartyApple: true },
  { displayName: "Apple Configurator", bundleId: "com.apple.ios.configurator", isFirstPartyApple: true },
  { displayName: "Apple Store", bundleId: "com.apple.store.Jolly", isFirstPartyApple: true },
  { displayName: "Apple Vision Pro", bundleId: "com.apple.visionproapp", isFirstPartyApple: true },
  { displayName: "Barcode Scanner", bundleId: "com.apple.BarcodeScanner", isFirstPartyApple: true },
  { displayName: "Books", bundleId: "com.apple.iBooks", isFirstPartyApple: true },
  { displayName: "Business Essentials", bundleId: "com.apple.business-essentials", isFirstPartyApple: true },
  { displayName: "Calculator", bundleId: "com.apple.calculator", isFirstPartyApple: true },
  { displayName: "Family Controls UI", bundleId: "com.apple.FCAuthenticationUI", isFirstPartyApple: true },
  { displayName: "User Authentication", bundleId: "com.apple.LocalAuthenticationUIService", isFirstPartyApple: true },
  { displayName: "Calendar", bundleId: "com.apple.mobilecal", isFirstPartyApple: true },
  { displayName: "Camera", bundleId: "com.apple.camera", isFirstPartyApple: true },
  { displayName: "Classical", bundleId: "com.apple.music.classical", isFirstPartyApple: true },
  { displayName: "Classroom", bundleId: "com.apple.classroom", isFirstPartyApple: true },
  { displayName: "Clips", bundleId: "com.apple.clips", isFirstPartyApple: true },
  { displayName: "Clock", bundleId: "com.apple.mobiletimer", isFirstPartyApple: true },
  { displayName: "Compass", bundleId: "com.apple.compass", isFirstPartyApple: true },
  { displayName: "Contacts", bundleId: "com.apple.MobileAddressBook", isFirstPartyApple: true },
  { displayName: "Developer", bundleId: "developer.apple.wwdc-Release", isFirstPartyApple: true },
  { displayName: "FaceTime", bundleId: "com.apple.facetime", isFirstPartyApple: true },
  { displayName: "Files", bundleId: "com.apple.DocumentsApp", isFirstPartyApple: true },
  { displayName: "Final Cut Camera", bundleId: "com.apple.FinalCutApp.companion", isFirstPartyApple: true },
  { displayName: "Final Cut Pro", bundleId: "com.apple.FinalCutApp", isFirstPartyApple: true },
  { displayName: "Find My", bundleId: "com.apple.findmy", isFirstPartyApple: true },
  { displayName: "Fitness", bundleId: "com.apple.Fitness", isFirstPartyApple: true },
  { displayName: "Freeform", bundleId: "com.apple.freeform", isFirstPartyApple: true },
  { displayName: "Games", bundleId: "com.apple.games", isFirstPartyApple: true },
  { displayName: "GarageBand", bundleId: "com.apple.mobilegarageband", isFirstPartyApple: true },
  { displayName: "Health", bundleId: "com.apple.Health", isFirstPartyApple: true },
  { displayName: "Home", bundleId: "com.apple.Home", isFirstPartyApple: true },
  { displayName: "iCloud Drive", bundleId: "com.apple.iCloudDriveApp", isFirstPartyApple: true },
  { displayName: "iMovie", bundleId: "com.apple.iMovie", isFirstPartyApple: true },
  { displayName: "Invites", bundleId: "com.apple.rsvp", isFirstPartyApple: true },
  { displayName: "iTunes Store", bundleId: "com.apple.MobileStore", isFirstPartyApple: true },
  { displayName: "Journal", bundleId: "com.apple.journal", isFirstPartyApple: true },
  { displayName: "Keynote", bundleId: "com.apple.Keynote", isFirstPartyApple: true },
  { displayName: "Logic Pro", bundleId: "com.apple.mobilelogic", isFirstPartyApple: true },
  { displayName: "Logic Remote", bundleId: "com.apple.musicapps.remote", isFirstPartyApple: true },
  { displayName: "Magnifier", bundleId: "com.apple.Magnifier", isFirstPartyApple: true },
  { displayName: "Mail", bundleId: "com.apple.mobilemail", isFirstPartyApple: true },
  { displayName: "Maps", bundleId: "com.apple.Maps", isFirstPartyApple: true },
  { displayName: "Measure", bundleId: "com.apple.measure", isFirstPartyApple: true },
  { displayName: "Messages", bundleId: "com.apple.MobileSMS", isFirstPartyApple: true },
  { displayName: "Music", bundleId: "com.apple.Music", isFirstPartyApple: true },
  { displayName: "News", bundleId: "com.apple.news", isFirstPartyApple: true },
  { displayName: "Notes", bundleId: "com.apple.mobilenotes", isFirstPartyApple: true },
  { displayName: "Numbers", bundleId: "com.apple.Numbers", isFirstPartyApple: true },
  { displayName: "Pages", bundleId: "com.apple.Pages", isFirstPartyApple: true },
  { displayName: "Passwords", bundleId: "com.apple.Passwords", isFirstPartyApple: true },
  { displayName: "Phone", bundleId: "com.apple.mobilephone", isFirstPartyApple: true },
  { displayName: "Photo Booth", bundleId: "com.apple.Photo-Booth", isFirstPartyApple: true },
  {
    displayName: "Photomator",
    bundleId: "com.pixelmatorteam.pixelmator.touch.x.photo",
    isFirstPartyApple: false,
  },
  { displayName: "Photos", bundleId: "com.apple.mobileslideshow", isFirstPartyApple: true },
  {
    displayName: "Pixelmator Classic iOS",
    bundleId: "com.pixelmatorteam.pixelmator.touch",
    isFirstPartyApple: false,
    brandfetchSearchQuery: "Pixelmator",
  },
  { displayName: "Playground", bundleId: "com.apple.GenerativePlaygroundApp", isFirstPartyApple: true },
  { displayName: "Podcasts", bundleId: "com.apple.podcasts", isFirstPartyApple: true },
  { displayName: "Preview", bundleId: "com.apple.Preview", isFirstPartyApple: true },
  { displayName: "Reality Composer", bundleId: "com.apple.RealityComposer", isFirstPartyApple: true },
  { displayName: "Reminders", bundleId: "com.apple.reminders", isFirstPartyApple: true },
  { displayName: "Research", bundleId: "com.apple.Research", isFirstPartyApple: true },
  { displayName: "Safari", bundleId: "com.apple.mobilesafari", isFirstPartyApple: true },
  { displayName: "Schoolwork", bundleId: "com.apple.schoolwork.ClassKitApp", isFirstPartyApple: true },
  { displayName: "Settings", bundleId: "com.apple.Preferences", isFirstPartyApple: true },
  { displayName: "Screenshot UI", bundleId: "com.apple.ScreenshotServicesService", isFirstPartyApple: true },
  { displayName: "Shazam", bundleId: "com.shazam.Shazam", isFirstPartyApple: false },
  { displayName: "Shortcuts", bundleId: "com.apple.shortcuts", isFirstPartyApple: true },
  { displayName: "Sports", bundleId: "com.apple.sports", isFirstPartyApple: true },
  { displayName: "Stocks", bundleId: "com.apple.stocks", isFirstPartyApple: true },
  { displayName: "Swift Playground", bundleId: "com.apple.Playgrounds", isFirstPartyApple: true },
  { displayName: "TestFlight", bundleId: "com.apple.TestFlight", isFirstPartyApple: true },
  { displayName: "Tips", bundleId: "com.apple.tips", isFirstPartyApple: true },
  { displayName: "Translate", bundleId: "com.apple.Translate", isFirstPartyApple: true },
  { displayName: "TV", bundleId: "com.apple.tv", isFirstPartyApple: true },
  { displayName: "Wallet", bundleId: "com.apple.Passbook", isFirstPartyApple: true },
  { displayName: "Watch", bundleId: "com.apple.Bridge", isFirstPartyApple: true },
  { displayName: "Weather", bundleId: "com.apple.weather", isFirstPartyApple: true },
];

function normalizeKey(value: string): string {
  return value.trim().toLowerCase();
}

function lastSegment(value: string): string {
  return value.trim().split(".").pop()?.toLowerCase() ?? "";
}

function toMatch(app: AppleSystemAppDefinition): AppleSystemAppMatch {
  return {
    officialDisplayName: app.displayName,
    bundleId: app.bundleId,
    isFirstPartyApple: app.isFirstPartyApple,
    brandfetchSearchQuery: app.brandfetchSearchQuery
      ?? (app.isFirstPartyApple ? `Apple ${app.displayName}` : app.displayName),
  };
}

const BUNDLE_ID_LOOKUP = new Map(
  APPLE_SYSTEM_APPS.map((app) => [normalizeKey(app.bundleId), toMatch(app)]),
);

const DISPLAY_NAME_LOOKUP = new Map(
  APPLE_SYSTEM_APPS.map((app) => [normalizeKey(app.displayName), toMatch(app)]),
);

const LAST_SEGMENT_LOOKUP = new Map(
  APPLE_SYSTEM_APPS.map((app) => [lastSegment(app.bundleId), toMatch(app)]),
);

const QUIRK_LOOKUP = new Map<string, AppleSystemAppMatch>([
  ["preferences", BUNDLE_ID_LOOKUP.get("com.apple.preferences")!],
]);

/** Bundle ids that are UI-service variants of an already-cataloged app. */
const BUNDLE_ID_ALIASES: Record<string, string> = {
  // The pass-detail-sheet process — resolves to the same Wallet entry as com.apple.Passbook.
  "com.apple.passbookuiservice": "com.apple.passbook",
};

function lookupIdentifier(value: string): AppleSystemAppMatch | null {
  const normalized = normalizeKey(value);
  const direct = BUNDLE_ID_LOOKUP.get(normalized);
  if (direct) return direct;

  const aliasTarget = BUNDLE_ID_ALIASES[normalized];
  return aliasTarget ? BUNDLE_ID_LOOKUP.get(aliasTarget) ?? null : null;
}

function lookupDisplayName(value: string): AppleSystemAppMatch | null {
  const normalized = normalizeKey(value);
  return DISPLAY_NAME_LOOKUP.get(normalized) ?? null;
}

function lookupLastSegment(value: string): AppleSystemAppMatch | null {
  const normalized = normalizeKey(value);
  return LAST_SEGMENT_LOOKUP.get(normalized) ?? QUIRK_LOOKUP.get(normalized) ?? null;
}

export function resolveAppleSystemApp({
  displayName,
  appIdentifier,
}: {
  displayName?: string | null;
  appIdentifier?: string | null;
}): AppleSystemAppMatch | null {
  const trimmedId = (appIdentifier ?? "").trim();
  const trimmedDisplay = (displayName ?? "").trim();

  if (trimmedId) {
    const identifierMatch = lookupIdentifier(trimmedId);
    if (identifierMatch) return identifierMatch;

    const normalizedId = normalizeKey(trimmedId);
    const isGenericAppleLabel = normalizeKey(trimmedDisplay) === "apple";
    const shouldTryIdentifierSegment =
      !trimmedId.includes(".") ||
      normalizedId.startsWith("com.apple.") ||
      isGenericAppleLabel;

    if (shouldTryIdentifierSegment) {
      const identifierSegmentMatch = lookupLastSegment(trimmedId);
      if (identifierSegmentMatch) return identifierSegmentMatch;
    }

    // Do not match Apple catalog entries from displayName when Screen Time already
    // provided a distinct third-party bundle id.
    if (!normalizedId.startsWith("com.apple.") && !isGenericAppleLabel) {
      return null;
    }
  }

  if (trimmedDisplay) {
    const displayIdentifierMatch = lookupIdentifier(trimmedDisplay);
    if (displayIdentifierMatch) return displayIdentifierMatch;

    const displayNameMatch = lookupDisplayName(trimmedDisplay);
    if (displayNameMatch) return displayNameMatch;

    const displaySegmentMatch = lookupLastSegment(trimmedDisplay);
    if (displaySegmentMatch) return displaySegmentMatch;
  }

  return null;
}
